import { Box, ButtonBase } from "@mui/material";
import { landingColors } from "../../landingColors";
import { stepGroups } from "../../data/buyerSellerStepsData";

// Group tabs for the steps section. These stay live at both breakpoints: the
// scroll/swipe sequence moves the highlight automatically, and clicking a tab
// jumps to that group's first step. The outer box centres the (inline) rail,
// so callers can drop this into a full-width sticky bar without extra layout.
const StepsTabToggle = ({ activeGroup, onSelect, sx }) => (
  <Box sx={{ display: "flex", justifyContent: "center", ...sx }}>
    <Box
      role="tablist"
      sx={{
        display: "inline-flex",
        borderBottom: `2px solid ${landingColors.border}`,
      }}
    >
      {stepGroups.map((group) => {
        const isActive = activeGroup === group.key;
        return (
          <ButtonBase
            key={group.key}
            role="tab"
            aria-selected={isActive}
            onClick={() => onSelect(group.key)}
            sx={{
              px: { xs: 2.5, md: 3.5 },
              py: 1.25,
              fontWeight: 700,
              fontSize: { xs: 17, md: 20 },
              lineHeight: 1.3,
              color: isActive
                ? landingColors.primary
                : landingColors.textSecondary,
              borderBottom: `2px solid ${isActive ? landingColors.primary : "transparent"}`,
              mb: "-2px",
              transition: "color 0.2s ease, border-color 0.2s ease",
            }}
          >
            {group.label}
          </ButtonBase>
        );
      })}
    </Box>
  </Box>
);

export default StepsTabToggle;
